export default [
    {
        name: "Michael D'Silva",
        degree: "B.E.Sc. Software Engineering",
        email: ["mailto:mdsilva6@uwo.ca", "mdsilva6@uwo.ca"],
        linkedin: ["https://linkedin.com/in/michaelddsilva", "linkedin.com/in/michaelddsilva"],
        github: ["https://github.com/michaelddsilva", "github.com/michaelddsilva"],
        favouriteLanguages: ["JavaScript", "C#", "Java"],
        favouriteFramework: "Vue.js",
        skillSets: ["Full Stack Development", "Consulting"]
    }
]